import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Campaigns from './Campaigns';
import CampaignsSnapshot from './CampaignsSnapshot';

/**
 * Router component that decides whether to render:
 * - Campaigns component for live/current data (URL: /campaigns)
 * - CampaignsSnapshot component for snapshot data (URL: /campaigns?snapshotMonth=2025-06)
 */
const CampaignsRouter = () => {
  const [searchParams] = useSearchParams();
  
  // Check if there's a snapshotMonth parameter
  const snapshotMonth = searchParams.get('snapshotMonth');
  
  // Log for debugging
  useEffect(() => {
    if (snapshotMonth) {
      console.log(`CampaignsRouter: Rendering snapshot view for ${snapshotMonth}`);
    } else {
      console.log('CampaignsRouter: Rendering live campaigns view');
    }
  }, [snapshotMonth]);
  
  // If snapshot month is provided, render CampaignsSnapshot
  // Otherwise, render the regular Campaigns component
  return snapshotMonth ? <CampaignsSnapshot /> : <Campaigns />;
};

export default CampaignsRouter; 